import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje2 } from '../mensajes2'; 

import { Mensaje } from '../../components/mensajes';

import useTable from "../../components/useTable"
import Controls from "../../components/controls/Controls";
import { Dimmer } from '../../components/spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';

const TablaCuenta = props => {

    /*  variables de estados */

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [idefiscal, setIdefiscal] = useState(localStorage.getItem('idefiscal'));
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);
    const [values, setValues] = useState({});


    const headCells = [
        { id: 'idcu', label: 'ID', width: '10px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'codcuenta', label: 'CODIGO', width: '40px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: 'descri', label: 'DESCRIPCIÓN', width: '600px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    ]

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.codcuenta.toLowerCase().includes(target.value.toLowerCase())
                            || x.idcu.toLowerCase().includes(target.value.toLowerCase())
                            || x.descri.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarCuenta = (idefiscal) => {

        let endpoint = `${op.conexion}/api/catalogo/cuentaconta?idefiscal=${idefiscal}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {


            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data)
                }

            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setActivate(false);

        })

    }

    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }

    const seleccionarCus = (index) => (event) => {

        var valor = { idcu: values.idcu, codcuenta: values.codcuenta, descri: values.descri }

        console.log(valor)
        blanquear();
        props.onHideAceptaCatCta(valor);


    };

    const handleCloseMensa = () => {
        setMostrar(false);
    }

    const cancelar = () => {

        blanquear();
        props.onHideCloseCta();
    }

    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);

        setValues(recordsAfterPagingAndSorting()[index]);
    };

    const seleccionarLista = (index) => (event) => {

     



        var valor = { idcu: values.idcu, codcuenta: values.codcuenta, descri: values.descri }

        console.log(valor)
        blanquear();
        props.onHideAceptaCatCta(valor);

    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarCuenta(idefiscal)
            }}
        >
            <Modal.Header className='azulGradiant modal-header'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Cuenta Contable.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12" style={{ marginBottom: "10px" }}>
                    <div className="col-md-12 m-0">

                        <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                            <input type='text'
                                onChange={handleSearch} className="form-control search-input rounded-pill" />
                        </div>
                    </div>

                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.codcuenta}  style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "10px", verticalAlign: "middle" }}>{item.idcu}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "40px", verticalAlign: "middle" }}>{item.codcuenta}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "60px", verticalAlign: "middle" }}>{item.descri}</td>

                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
            <button className="btn btn-sm btn-success rounded-pill" disabled={activo} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>

                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default TablaCuenta;